import { Button } from 'react-bootstrap';
import styles from './LockedButton.module.scss';
import lockIcon from '../../images/lock-icon.png';

interface Props {
  small?: boolean;
  disabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const LockedButton = ({ small, disabled, ...otherProps }: Props) => (
  <div className={styles.cardLock}>
    <Button {...otherProps} className={styles.cardLock}>
      <img src={lockIcon} alt='lock icon' className={styles.lockIcon} />
    </Button>
  </div>
);

export default LockedButton;
